import React from 'react';
import PropTypes from 'prop-types';
import ItemMenu from '../../ItemMenu/ItemMenu';
import styles from '../logged-navigation.module.scss';

export const MenuMatchesFavoritesTours = ({ className, routesNav }) => {
  return routesNav.map((route, index) => <ItemMenu className={styles.item} {...route} key={index} />);
};

MenuMatchesFavoritesTours.propTypes = {
  className: PropTypes.string,
  routesNav: PropTypes.array,
};
